/**
 * Accounts page — houses the accounting sub-modules:
 *   1. Invoices           (placeholder — to be built later)
 *   2. Petty Cash         (receipts / payments ledger with running balance)
 *   3. Credit Card Expenses (company card spend, separate from petty cash)
 *   4. Utility Bills
 */
import { useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import useDeviceDetection from '../hooks/useDeviceDetection';
import PettyCash from '../components/PettyCash';
import CreditCardExpenses from '../components/CreditCardExpenses';
import UtilityBills from '../components/UtilityBills';
import DrivingLicenseExpenses from '../components/DrivingLicenseExpenses';
import RentalExpenses from '../components/RentalExpenses';
import CustomerInvoices from '../components/CustomerInvoices';

const Accounts = ({ user }) => {
  const { isMobile } = useDeviceDetection();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'invoices';

  const handleTabChange = (val) => {
    setSearchParams({ tab: val });
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <h1
        className={`font-bold text-slate-800 ${isMobile ? 'text-2xl' : 'text-4xl'}`}
        data-testid="accounts-page-title"
      >
        Accounts
      </h1>

      <Tabs value={tab} onValueChange={handleTabChange}>
        <TabsList className="flex flex-wrap w-full h-auto justify-start gap-1 p-1">
          <TabsTrigger value="invoices" data-testid="accounts-tab-invoices" className="flex-1 min-w-[110px]">
            Invoices
          </TabsTrigger>
          <TabsTrigger value="petty-cash" data-testid="accounts-tab-petty-cash" className="flex-1 min-w-[110px]">
            Petty Cash
          </TabsTrigger>
          <TabsTrigger value="credit-card-expenses" data-testid="accounts-tab-credit-card-expenses" className="flex-1 min-w-[170px]">
            Credit Card Expenses
          </TabsTrigger>
          <TabsTrigger value="utility-bills" data-testid="accounts-tab-utility-bills" className="flex-1 min-w-[130px]">
            Utility Bills
          </TabsTrigger>
          <TabsTrigger value="driving-license-expenses" data-testid="accounts-tab-driving-license-expenses" className="flex-1 min-w-[190px]">
            Driving License Expenses
          </TabsTrigger>
          <TabsTrigger value="rental-expenses" data-testid="accounts-tab-rental-expenses" className="flex-1 min-w-[200px]">
            Property Rental Expenses
          </TabsTrigger>
        </TabsList>

        <TabsContent value="invoices" className="mt-4">
          <CustomerInvoices />
        </TabsContent>

        <TabsContent value="petty-cash" className="mt-4">
          <PettyCash user={user} />
        </TabsContent>

        <TabsContent value="credit-card-expenses" className="mt-4">
          <CreditCardExpenses user={user} />
        </TabsContent>

        <TabsContent value="utility-bills" className="mt-4">
          <UtilityBills />
        </TabsContent>

        <TabsContent value="driving-license-expenses" className="mt-4">
          <DrivingLicenseExpenses />
        </TabsContent>

        <TabsContent value="rental-expenses" className="mt-4">
          <RentalExpenses />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Accounts;
